module.exports = __webpack_public_path__ + "static/img/bcgSongs_zaiks.727e15c1.png";